const {Backbone} = require('backboneAdapter');
import _ from 'underscore';
require('backbone-relational');

const Balloon = Backbone.RelationalModel.extend({
    subModelTypes: {
        'completion': 'CCCIdCarrier',
        // Download does not have cccId.
        'download': 'Download',
        'email': 'CCCIdCarrier',
        'optin': 'CCCIdCarrier',
        'optout': 'CCCIdCarrier',
        'payment': 'CCCIdCarrier',
        'redemption': 'CCCIdCarrier',
        'sms': 'CCCIdCarrier',
        'url': 'CCCIdCarrier'
    },
    defaults: {
        type: '',
    },
});

const CCCIdCarrier = Balloon.extend({
    subModelTypes: {
        'completion': 'MessageCarrier',
        'email': 'MessageCarrier',
        'optin': 'MessageCarrier',
        // Optout has predefined message.
        'optout': 'Optout',
        'payment': 'MessageCarrier',
        'redemption': 'MessageCarrier',
        'sms': 'MessageCarrier',
        // Url has the url as balloon content.
        'url': 'Url'
    },
    defaults: _.extend(Balloon.prototype.defaults, {
        cccId: '',
    })
});

const MessageCarrier = CCCIdCarrier.extend({
    subModelTypes: {
        'completion': 'Completion',
        'email': 'Bulk',
        'optin': 'Optin',
        'payment': 'Payment',
        'redemption': 'Redemption',
        'sms': 'Bulk',
    },
    defaults: _.extend(CCCIdCarrier.prototype.defaults, {
       message: ''
    })
});

// Email and Sms share a lot of properties.
const Bulk = MessageCarrier.extend({
    subModelTypes: {
        'email': 'Email',
        'sms': 'Sms'
    },
    defaults: _.extend(MessageCarrier.prototype.defaults, {
        containsFile: false,
        containsOptout: false,
        containsSurvey: false,
        containsUrl: false,
        containsVoucher: false,
        fileDownloaded: false,
        optedOut: false,
        redeemed: false,
        sender: '',
        sentDate: '',
        status: "NOT_DELIVERED",
        surveyFilledIn: false,
        urlViewed: false,
    })
});

const Sms = Bulk.extend({
    defaults: _.extend(Bulk.prototype.defaults, {
        smsCount: 0,
    })
});

const Email = Bulk.extend({
    defaults: _.extend(Bulk.prototype.defaults, {
        emailCount: 0,
        subject: '',
    })
});

const Redemption = MessageCarrier.extend({
    defaults: _.extend(MessageCarrier.prototype.defaults, {
        redemptionDate: '',
        sentCodesCount: 0
    })
});

const Completion = MessageCarrier.extend({
   defaults: _.extend(MessageCarrier.prototype.defaults, {
       completionDate: '',
       description: '',
       rating: 0,
       sentCodesCount: 0
   })
});

const Download = Balloon.extend({
    defaults: _.extend(Balloon.prototype.defaults, {
        contentId: '',
        downloadDate: '',
        fileName: '',
        fileSize: '',
    })
});

const Url = CCCIdCarrier.extend({
    default: _.extend(CCCIdCarrier.prototype.defaults, {
        url: '',
        urlViewDate: '',
    })
});

const Optin = MessageCarrier.extend({
    defaults: _.extend(MessageCarrier.prototype.defaults, {
        acquisitions: 0,
        optinDate: '',
        visits: 0,
    })
});

const Payment = MessageCarrier.extend({
    defaults: _.extend(MessageCarrier.prototype.defaults, {
        buyers: 0,
        paymentDate: '',
    })
});

const Optout = CCCIdCarrier.extend({
    defaults: _.extend(CCCIdCarrier.prototype.defaults, {
        optedOutDate: '',
    })
});

export default Balloon;
